<div class="reviews-filter__container-outer">
  <form [formGroup]="form" class="reviews-filter__container-inner">
    <div class="reviews-filter__filter" *ngFor="let used of usedFilters; let uIdx = index">
      <button class="reviews-filter__filter-remove  vox-btn vox-btn-secondary-grey" type="button"
        (click)="removeFilter(uIdx)" [ngClass]="{'hidden': usedFilters.length === 1}">
        <i class="reviews-filter__filter-remove_symbol icon-small-remove"></i>
      </button>
      <div ngbDropdown class="reviews-filter__filter-dropdown">
        <button class="reviews-filter__filter-dropdown_btn" id="filter-dropdown" ngbDropdownToggle
          [disabled]="availableFilters.length < 1">
          {{'reviews.filters.fields.' + used | translate}}
        </button>
        <div ngbDropdownMenu aria-labelledby="filter-dropdown">
          <button ngbDropdownItem class="reviews-filter__filter-dropdown_item" type="button"
            *ngFor="let filter of availableFilters; let idx = index" (click)="updateFilters(idx, uIdx)">
            {{'reviews.filters.fields.' + filter | translate}}
          </button>
        </div>
        <div class="reviews-filter__filter-input" [ngSwitch]="used">
          <div class="vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="company_id" *ngSwitchCase="'company_id'"
              (keydown.enter)="emitFilters($event)">
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-select-company-associated formControlName="is_company_associated"
              *ngSwitchCase="'is_company_associated'">
            </gdp-select-company-associated>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-date-picker formControlName='timestamp_from' [maxDate]="startDay" *ngSwitchCase="'timestamp_from'">
            </gdp-date-picker>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-date-picker formControlName='timestamp_to' [maxDate]="startDay" *ngSwitchCase="'timestamp_to'">
            </gdp-date-picker>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-select-platform formControlName="platform" *ngSwitchCase="'platform'"></gdp-select-platform>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-select-rating formControlName="rating_from" *ngSwitchCase="'rating_from'"
              [selectedRating]="RATINGS[0]"></gdp-select-rating>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-select-rating formControlName="rating_to" *ngSwitchCase="'rating_to'" [selectedRating]="RATINGS[4]">
            </gdp-select-rating>
          </div>
        </div>
      </div>
    </div>
    <div class="reviews-filter__filter-add_container">
      <button class="vox-btn vox-btn-secondary reviews-filter__filter-add" type="button" (click)="addFilter(0)"
        [disabled]="availableFilters.length < 1">
        <i class="reviews-filter__filter-add_symbol icon-small-add">
        </i>
      </button>
      <button class="vox-btn vox-btn-secondary reviews-filter__filter-apply" type="submit"
        [disabled]="form.invalid || !usedFilters.length" (click)="emitFilters(null)">
        {{'reviews.filters.actions.apply-filters' | translate}}
      </button>
      <button class="ml-2 btn btn-link reviews-filter__filter-clear" type="button" (click)="resetFilters()">
        {{'reviews.filters.actions.clear-filters' | translate}}
      </button>
    </div>
  </form>
</div>